(function($) {
  $('#boxclose').click(function(){
    window.history.back();
  })

  $(document).ready(function() {

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll > 5) {
        $(".kopfzeile").css("background-color", "rgba(0, 0, 0, 70%)");
      }
      if (scroll < 1) {
        $(".kopfzeile").css("background-color", "transparent");
      }
    });
    // Sidebar active Link
    $(function() {
		$('ul.navbar-nav li a').each(function() {
			var isActive = this.pathname === location.pathname;
			$(this).toggleClass('active', isActive);
		});
    });
	var myOffcanvas = document.getElementById('offcanvasNavbar')
	myOffcanvas.addEventListener('show.bs.offcanvas', function () {
			console.log('show')
			$('ul.navbar-nav li a').each(function() {
				var isActive = this.pathname === location.pathname;
				$(this).toggleClass('active', false);
			});
		})
  });
}) (jQuery);

// init Packery
var grid = document.querySelector('.grid');
var pckry = new Packery( grid, {
  itemSelector: '.grid-item',
  columnWidth: '.grid-sizer',
  transitionDuration: '0.2s',
  percentPosition: true
});
// layout Packery after each image loads
imagesLoaded( grid ).on( 'progress', function() {
  pckry.layout();
});

